import React from 'react'
import { Accordion } from '../../../../../common/Accordion'
import { AccordionCustomItem, AccordionItem } from './AccordionItem'
import type { QuantityAccordionProps } from './types'

export const QuantityAccordion = ({
  accordionState,
  autoAdjustedSellingPrice,
  data,
  includeFeesValue,
  soldValue,
  soldValueError,
  onChange,
  onSoldValueChange,
}: QuantityAccordionProps) => {
  return (
    <Accordion>
      {accordionState.map((state, index) => {
        const dataItem = data.quantityPricing?.length ? data.quantityPricing[index] : undefined

        if (dataItem) {
          return index === accordionState.length - 1 ? (
            <AccordionCustomItem
              autoAdjustedSellingPrice={autoAdjustedSellingPrice}
              data={dataItem}
              expanded={state}
              includeFeesValue={includeFeesValue}
              key={`${dataItem.numberOfUnits}-${index}`}
              soldValue={soldValue}
              soldValueError={soldValueError}
              onChange={() => onChange(index)}
              onSoldValueChange={onSoldValueChange}
            />
          ) : (
            <AccordionItem
              autoAdjustedSellingPrice={autoAdjustedSellingPrice}
              data={dataItem}
              expanded={state}
              includeFeesValue={includeFeesValue}
              isMinimumQuantity={index === 0}
              key={`${dataItem.numberOfUnits}-${index}`}
              onChange={() => onChange(index)}
            />
          )
        }
      })}
    </Accordion>
  )
}
